import { uniqueId } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants'

export const parseDataAttributeJson = (
  elementJson,
  { fallbackId, fallbackType } = {
    fallbackId: API_CONSTANTS.ELEMENT.TYPE,
    fallbackType: API_CONSTANTS.ELEMENT.TYPE,
  },
) => {
  try {
    const { data = {} } = JSON.parse(elementJson)
    const { id, type, links = {}, meta = {}, attributes = {}, relationships = {} } = data
    return {
      id,
      type,
      links,
      meta,
      attributes,
      relationships,
    }
  } catch (error) {
    return {
      id: uniqueId(`empty-${fallbackId}_`),
      type: fallbackType,
      links: {},
      attributes: {},
      relationships: {},
    }
  }
}
